import AdminSwitch from './AdminSwitch.jsx';

export default AdminSwitch;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/AdminControls/AdminSwitch/index.js